
import React from "react";
import { UseFormRegister, FieldErrors } from "react-hook-form";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { CourseFormData } from "../types";

interface JsonFieldsProps {
  register: UseFormRegister<CourseFormData>;
  errors: FieldErrors<CourseFormData>;
}

export function JsonFields({ register, errors }: JsonFieldsProps) {
  const validateJSON = (value: string) => {
    if (!value) return true; // Allow empty
    try {
      JSON.parse(value);
      return true;
    } catch (e) {
      return "Invalid JSON format";
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div className="space-y-2">
        <Label htmlFor="benefits">
          Benefits (Optional, JSON format)
          <span className="ml-1 text-xs text-muted-foreground">e.g., {`["Title", "Benefit 1", "Benefit 2"]`}</span>
        </Label>
        <Textarea
          id="benefits"
          className="h-24"
          {...register("benefits", { 
            validate: validateJSON
          })}
          placeholder='["Benefit 1", "Benefit 2", "Benefit 3"]'
        />
        {errors.benefits && <p className="text-sm text-red-500">{errors.benefits.message}</p>}
      </div>

      <div className="space-y-2">
        <Label htmlFor="footer_text">
          Footer Text (Optional, JSON format)
          <span className="ml-1 text-xs text-muted-foreground">e.g., {`{"headline": "Note", "text": "Important information"}`}</span>
        </Label>
        <Textarea
          id="footer_text"
          className="h-24"
          {...register("footer_text", { 
            validate: validateJSON
          })}
          placeholder='{"headline": "Note", "text": "Important information"}'
        />
        {errors.footer_text && <p className="text-sm text-red-500">{errors.footer_text.message}</p>}
      </div>
    </div>
  );
}
